import { TableToolbar } from '@wix/design-system';
import { CollectionSearch, CollectionSearchProps } from '../CollectionSearch';
import React from 'react';
import { FilterElement } from '../CollectionToolbarFilters';
import { CollectionState, FiltersMap } from '@wix/bex-core';
import { classes, st } from './SearchOrCustomFilter.st.css.js';

export interface SearchOrCustomFilterProps<T, F extends FiltersMap> {
  search: true | FilterElement;
  state: CollectionState<T, F>;
  onSearchChange?: CollectionSearchProps<T, F>['onSearchChange'];
  onSearchClick?: CollectionSearchProps<T, F>['onSearchClick'];
  onSearchBlur?: CollectionSearchProps<T, F>['onSearchBlur'];
  searchMaxLength?: CollectionSearchProps<T, F>['maxLength'];
}

export function SearchOrCustomFilter<T, F extends FiltersMap>(
  props: SearchOrCustomFilterProps<T, F>,
) {
  const {
    search,
    state,
    onSearchChange,
    onSearchClick,
    onSearchBlur,
    searchMaxLength,
  } = props;

  let child;

  if (search === true) {
    child = (
      <CollectionSearch
        state={state}
        size="small"
        onSearchChange={onSearchChange}
        onSearchClick={onSearchClick}
        onSearchBlur={onSearchBlur}
        maxLength={searchMaxLength}
      />
    );
  } else {
    child = search;
  }

  return (
    <TableToolbar.Item className={st(classes.search)}>
      {child}
    </TableToolbar.Item>
  );
}
